import React from "react";

export default function PoliticaPrivacidad() {
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "20px", lineHeight: "1.7" }}>
      <h1>Política de Privacidad</h1>

      <p>
        En <strong>BikeAndRide</strong> respetamos tu privacidad y nos comprometemos a proteger
        tus datos personales conforme al Reglamento General de Protección de Datos (RGPD)
        y la legislación vigente en materia de protección de datos.
      </p>

      <h2>1. Responsable del Tratamiento</h2>
      <p>
        <strong>BikeAndRide</strong> <br />
        Correo electrónico: <a href="mailto:contacto@bikeandride.com">contacto@bikeandride.com</a> <br />
        Dirección: El Molar, Madrid, España
      </p>

      <h2>2. Finalidad del Tratamiento</h2>
      <p>Tratamos tus datos personales con las siguientes finalidades:</p>
      <ul>
        <li>Gestionar tu registro y acceso a la aplicación.</li>
        <li>Proporcionar los servicios ofrecidos (rutas, actividades, comunidad).</li>
        <li>Atender consultas o incidencias.</li>
        <li>Mejorar la experiencia del usuario y la seguridad de la plataforma.</li>
        <li>Enviar comunicaciones relacionadas con el servicio.</li>
      </ul>

      <h2>3. Legitimación</h2>
      <p>
        La base legal para el tratamiento de tus datos es tu consentimiento,
        la ejecución del contrato de uso de la aplicación y, en determinados casos,
        el cumplimiento de obligaciones legales.
      </p>

      <h2>4. Conservación de los Datos</h2>
      <p>
        Los datos se conservarán mientras mantengas tu cuenta activa o durante el tiempo
        necesario para cumplir con obligaciones legales. Posteriormente, se bloquearán
        y conservarán únicamente para posibles responsabilidades legales.
      </p>

      <h2>5. Comunicación de Datos a Terceros</h2>
      <p>
        No cederemos tus datos a terceros, salvo obligación legal o cuando sea necesario
        para la prestación de servicios vinculados a la plataforma (p. ej. servicios de hosting).
      </p>

      <h2>6. Derechos de los Usuarios</h2>
      <p>
        Tienes derecho a:
      </p>
      <ul>
        <li>Acceder a tus datos personales.</li>
        <li>Rectificar datos inexactos o incompletos.</li>
        <li>Solicitar la supresión de tus datos.</li>
        <li>Solicitar la limitación u oposición al tratamiento.</li>
        <li>Solicitar la portabilidad de tus datos.</li>
      </ul>
      <p>
        Puedes ejercer estos derechos enviando un correo a:{" "}
        <a href="mailto:contacto@bikeandride.com">contacto@bikeandride.com</a>
      </p>

      <h2>7. Seguridad de los Datos</h2>
      <p>
        Adoptamos medidas técnicas y organizativas adecuadas para garantizar la
        seguridad de la información y evitar accesos no autorizados, pérdida o divulgación indebida.
      </p>

      <h2>8. Cambios en la Política de Privacidad</h2>
      <p>
        Nos reservamos el derecho a modificar esta política de privacidad en cualquier momento.
        Cualquier cambio será publicado en esta página y entrará en vigor desde su actualización.
      </p>

      <p><strong>Última actualización:</strong> 1 de septiembre de 2025</p>
    </div>
  );
}